import type { ReactNode } from "react";
import { useFetchLegalPage, useFetchTermsAndConditionsStatus, useUpdateTermsAndConditionsStatus } from "@akina/infra";
import { LegalUpdateModal } from "./LegalUpdateModal";

type UpdatedPrivacyPolicyAcceptanceModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  app: "care" | "portal";
  entity: "patient" | "therapist";
  messages: { title: string; description: ReactNode; buttonLabel: string; subtext?: ReactNode };
};

export function UpdatedPrivacyPolicyAcceptanceModal({
  open,
  onOpenChange,
  app,
  entity,
  messages,
}: Readonly<UpdatedPrivacyPolicyAcceptanceModalProps>) {
  const { data: legalPage } = useFetchLegalPage("privacy-policy-and-data-transparency", app);
  const { data: currentTerms } = useFetchTermsAndConditionsStatus(entity);
  const { mutate, isPending } = useUpdateTermsAndConditionsStatus({ onSuccess: () => onOpenChange(false) }, entity);

  function handleAccept() {
    if (!legalPage?.version || !currentTerms) return;
    mutate({
      dataPrivacyPolicyAccepted: true,
      dataPrivacyPolicyAcceptedTimestamp: new Date().toISOString(),
      termsAndConditionsAccepted: currentTerms.termsAndConditionsAccepted,
      termsAndConditionsAcceptedTimestamp: currentTerms.termsAndConditionsAcceptedTimestamp,
      privacyPolicyVersion: legalPage.version,
      termsVersion: currentTerms.termsVersion,
    });
  }

  return (
    <LegalUpdateModal
      open={open}
      title={messages.title}
      description={messages.description}
      buttonLabel={messages.buttonLabel}
      subtext={messages.subtext}
      isPending={isPending}
      onAccept={handleAccept}
    />
  );
}
